<template>
  <LabelledInput
    label="Display Type"
    helpful-tip="Select which type of table to display for each level:"
  >
    <LabelledInput
      v-for="level in displaySummaries"
      :key="level.key"
      :label="level.text"
    >
      <b-radio-group
        :checked="level.selected"
        :options="options(level.key)"
        class="btn-block"
        buttons
        button-variant="outline-primary"
        @input="updateSummaryTableConfig(level.key, $event)"
      />
    </LabelledInput>
  </LabelledInput>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import { SummaryTableOption, SummaryTableOptions } from '@/types'
import {
  PATH_ROOT,
  PATH_SUBROOT,
  SUMMARY_TABLE_CONFIG_KEY,
} from '@/constants'

const components = {
  LabelledInput,
}

@Component({ components })
export default class SelectDisplay extends Vue {
  get summaryTable () {
    return this.$typedStore.primary.app.config.summaryTable
  }

  get selectedPaths () {
    return this.$typedStore.primary.entities.tabs.primaryRootTabPaths.map(({ path, text }) => {
      let selected = 'none'
      if (path === PATH_ROOT) selected = this.summaryTable.root
      if (path === PATH_SUBROOT) selected = this.summaryTable.subroot
      return {
        text,
        key: path,
        selected,
      }
    })
  }

  get displaySummaries () {
    return [
      ...this.selectedPaths,
      ...Object.entries(this.summaryTable.levelOptions).map(([key, selected]) => ({
        text: `Level ${key}`,
        key,
        selected,
      })),
    ]
  }

  updateSummaryTableConfig (key: string, value: SummaryTableOption) {
    if (key === PATH_ROOT || key === PATH_SUBROOT) {
      this.$typedStore.primary.app.updateConfig({
        configPath: [SUMMARY_TABLE_CONFIG_KEY, key],
        value,
      })
    } else if (+key > 0) {
      this.$typedStore.primary.app.updateConfig({
        configPath: [SUMMARY_TABLE_CONFIG_KEY, 'levelOptions', +key],
        value,
      })
    }
  }

  options (key: string) {
    return [
      { text: 'None', value: SummaryTableOptions.NONE },
      { text: 'Summary', value: SummaryTableOptions.SUMMARY },
      { text: 'Child', value: SummaryTableOptions.CHILD, disabled: key === this.$typedStore.visualisationData.levelCount.toString() },
    ]
  }
}

</script>
